import { MenuItem } from '@material-ui/core'
import React from 'react'
const ViewIconsDropDown = ({ views, setOpenViewIcons }) => {
    const handleClose = () => {
        setOpenViewIcons(false)
    }
    return (
        <div
            style={{
                display: "flex",
                borderRadius: "4px",
                right: "2px",
                width: "200px",
                position: "absolute",
                textAlign: "center",
                backgroundColor: "#fff",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                zIndex: 100
            }}
        >
            {
                views.map((view, index) => (
                    <>
                        <MenuItem
                            key={index}
                            onClick={handleClose}>
                            <div >
                                {Object.values(view)}
                            </div>
                        </MenuItem>
                    </>
                ))
            }
        </div >
    )
}
export default ViewIconsDropDown